import React from 'react';

import MSimpleSelect from 'views/MSimpleSelect/MSimpleSelect';

import { MSimpleSelectOption } from 'views/MSimpleSelect/MSimpleSelect.model';

type Props<OptionValue extends string | number> = {
  value?: OptionValue | null;
  name?: string;
  invalid?: boolean;
  hideSelectedOptions?: boolean;
  disabled?: boolean;
  showSelected?: boolean;
  size?: string;
  options: MSimpleSelectOption<OptionValue>[];
  placeholder?: string;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
};

const MFormSimpleSelectView = <OptionValue extends string | number>(props: React.PropsWithChildren<Props<OptionValue>>): JSX.Element => {
  return (
    <MSimpleSelect
      name={props.name}
      disabled={props.disabled}
      invalid={props.invalid}
      value={props.value}
      options={props.options}
      placeholder={props.placeholder}
      className={props.className}
      onChange={props.onChange}
      onBlur={props.onBlur}
    ></MSimpleSelect>
  );
};

MFormSimpleSelectView.displayName = 'MFoMFormSimpleSelectViewrmSimpleSelect';
MFormSimpleSelectView.defaultProps = {};

export default MFormSimpleSelectView;
